import React from 'react';
import PropTypes from 'prop-types';

import ProgressBar from 'src/components/ProgressBar';

function Loader(props) {
    return <ProgressBar {...props} />;
}

Loader.propTypes = {
    type: PropTypes.string,
    mode: PropTypes.string,
    multicolor: PropTypes.bool
};

Loader.defaultProps = {
    type: 'circular',
    mode: 'indeterminate',
    multicolor: true
};

export default Loader;
